import React from 'react';
import PropTypes from 'prop-types';
import LocationCardFulfillmentTypeGridItem from 'locations/ui_components/LocationCardFulfillmentTypeGridItem';
import Box from '@material-ui/core/Box';
import PrimaryCta from 'base/components/PrimaryCta';
import Hours from 'locations/components/Hours';

const LocationCardFulfillmentMethod = ({
  buttonLabel,
  handleButtonClick,
  hours,
  isFullWidth,
  buttonDataTestId,
  hoursDataTestId,
  hoursLabel,
  disableButton
}) => (
  <LocationCardFulfillmentTypeGridItem isFullWidth={isFullWidth}>
    <PrimaryCta
      fullWidth
      handleClick={handleButtonClick}
      label={buttonLabel}
      dataTestId={buttonDataTestId}
      disabled={disableButton}
    />
    <Box mt={1} data-testid={hoursDataTestId}>
      <Hours data={hours} label={hoursLabel} />
    </Box>
  </LocationCardFulfillmentTypeGridItem>
);

LocationCardFulfillmentMethod.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  hours: PropTypes.object.isRequired,
  hoursDataTestId: PropTypes.string.isRequired,
  isFullWidth: PropTypes.bool,
  buttonDataTestId: PropTypes.string.isRequired,
  hoursLabel: PropTypes.string.isRequired,
  disableButton: PropTypes.bool
};

LocationCardFulfillmentMethod.defaultProps = {
  isFullWidth: false,
  disableButton: false
};

export default LocationCardFulfillmentMethod;
